import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Panel from '../../../../components/angle/Panel';
import Spinner from '../../../../components/Spinner/index';
import EditPortfolioForm from '../../components/PortfolioForm';
import { formInputValidation } from '../../../../services/helper/form-helper';
import {
    fetchCountries,
    fetchStates,
    fetchFundTypes
} from '../../../../services/redux/commonData/actions';
import {
    updatePendingPortfolio,
    updateEditPendingPortfolioPayload
} from '../../../../services/redux/employee/security/actions';
import { editPortfolio } from '../../../../services/redux/employee/portfolio/actions';

class EditPendingPortfolio extends Component {
    constructor(props) {
        super(props);
        this.portfolioFormRef = React.createRef();
    }
    componentDidMount() {
        let { fetchCountries, fetchStates, fetchFundTypes } = this.props;
        fetchCountries();
        fetchStates();
        fetchFundTypes();
    }

    onSaveApproveClick = () => {
        let { security, history, editPortfolio } = this.props;
        let payload = security.editPendingPortfolio;
        payload = { ...payload, approvedStatus: 2 };
        if (formInputValidation(this.portfolioFormRef.current)) {
            editPortfolio(payload).then(response => {
                if (response.status === 200) {
                    history.push('/pending-securities');
                }
            });
        }
    };

    onDenyClick = () => {
        let { security, history, editPortfolio } = this.props;
        let payload = security.editPendingPortfolio;
        payload = { ...payload, approvedStatus: 3 };
        editPortfolio(payload).then(response => {
            if (response.status === 200) {
                history.push('/pending-securities');
            }
        });
    };

    onCancelClick = () => {
        let { history } = this.props;
        history.push('/pending-securities');
    };

    render() {
        let {
            security,
            trust,
            commonData,
            updateEditPendingPortfolioPayload,
            roleName
        } = this.props;
        let isAdmin = roleName === 'Administrator';
        let saveApproveButton = isAdmin && (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSaveApproveClick}
            >
                Save & Approve
            </button>
        );

        let denyButton = isAdmin && (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onDenyClick}
            >
                Deny
            </button>
        );

        let cancelButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onCancelClick}
            >
                Back
            </button>
        );

        const buttonList = [saveApproveButton, denyButton, cancelButton];

        return (
            <div>
                <Panel
                    showHeader
                    header="Edit Pending Portfolio"
                    showFooter
                    footerComponents={buttonList}
                >
                    <div className="col-lg-6 col-md-8 col-sm-12">
                        <EditPortfolioForm
                            parentTrusts={trust.trusts}
                            portfolioData={security.editPendingPortfolio}
                            countryList={commonData.countries}
                            fundTypeList={commonData.fundTypes}
                            stateList={commonData.states}
                            updatePortfolioData={
                                updateEditPendingPortfolioPayload
                            }
                            formRef={this.portfolioFormRef}
                            isEditable={isAdmin}
                        />
                    </div>
                </Panel>
                {(security.fetching || trust.fetching) && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    security: state.employee.security,
    trust: state.employee.trust,
    commonData: state.commonData,
    roleName: state.authentication.user
        ? state.authentication.user.roleName
        : ''
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCountries,
            fetchStates,
            fetchFundTypes,
            updatePendingPortfolio,
            updateEditPendingPortfolioPayload,
            editPortfolio
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EditPendingPortfolio));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/PendingSecurities/EditPendingPortfolio.js